import styled from "styled-components";
import {Flex, Image} from "rebass";
import MdLaptop from "react-ionicons/lib/MdLaptop";
import MdAddCircle from "react-ionicons/lib/MdAddCircle";
import React from "react";
import {Paperclip} from "styled-icons/fa-solid";


export const LaptopIcon = (props) => (
	<MdLaptop {...props} color={'#969a9b'}/>
)
export const Plus = (props) => (
	<MdAddCircle {...props} color={'#969a9b'}/>
)



const StyledPaperclip = styled(Paperclip)`
font-size: '30px';
`

export const Folder = (props) => (
	<StyledPaperclip {...props} color={'#969a9b'} size={'20px'}/>
)


export const FileInputWrapper = styled(Flex)`
      display: inline-block;
	    //width: 200px;
	    height: 40px;
	    overflow: hidden;
	    position: relative;

    &  input[type="file"] {
		    font-size: 200px;
		    position: absolute;
		    top: 0;
		    right: 0;
		    opacity: 0;
		    z-index: 1000;
		 }
   

`

export const ImagePreview = styled(Image)`
	 display: block;
  max-width:345px;
  max-height:143px;
  width: auto;
  height: auto;	
  z-index: 999;

`